module.exports = __webpack_public_path__ + "static/media/empty-mobile-screen.3c8cf3c6.png";